export default function /* @ngInject */ usaStates(cachedResource, config) {
    return cachedResource(config.accountsApiUrl + '/api/v1/stripe/us-states');
}



// WEBPACK FOOTER //
// ./data/services/usa-states.js